import React, { useEffect } from 'react';
import { Wrapper, TableContainer } from './styled';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGetAdminProviders, fetchUpdateProviderStatus } from '../../../../actions/admin';
import InputWrapper from '../../../common/InputWrapper';

const ServiceProviders = () => {
  const dispatch = useDispatch();
  const providers = useSelector((state) => state.admin.providers);

  useEffect(() => {
    dispatch(fetchGetAdminProviders());
  }, [dispatch]);

  const handleUpdateProviderStatus = (status, id) => {
    dispatch(fetchUpdateProviderStatus({ status, id })).then(() => {
      dispatch(fetchGetAdminProviders());
    });
  };

  return (
    <Wrapper>
      {providers !== null && (
        <>
          <div className="border-bottom">
            <h4 className="header-title">Фулфилмент провайдеры</h4>
          </div>
          <TableContainer>
            <div className="fixed-table-container">
              <div className="fixed-table-body">
                <table className="table table-centered">
                  <thead className="thead-light">
                    <tr>
                      <th>IsActive</th>
                      <th>createTs</th>
                      <th>serviceProviderType</th>
                      <th>warehouseFulfillmentType</th>
                      <th>warehouseFulfillmentSubType</th>
                      <th>fullName</th>
                      <th>message</th>
                      <th>status: New/finished</th>
                    </tr>
                  </thead>
                  <tbody>
                    {providers.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <InputWrapper type="checkbox" checked={item.isActive} />
                          </td>
                          <td>{item.createTs}</td>
                          <td>{item.serviceProviderType}</td>
                          <td>{item.warehouseFulfillmentType}</td>
                          <td>{item.warehouseFulfillmentSubType}</td>
                          <td>{item.fullName}</td>
                          <td>{item.message}</td>
                          <td>
                            {item.status || 'NEW'}
                            <InputWrapper
                              type="checkbox"
                              checked={item.status === 'FINISHED'}
                              onChange={() =>
                                handleUpdateProviderStatus(
                                  item.status === 'FINISHED' ? 'NEW' : 'FINISHED',
                                  item.id,
                                )
                              }
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </TableContainer>
        </>
      )}
    </Wrapper>
  );
};

export default ServiceProviders;
